<template>
  <TemplateContentSubNav ref="pageContent">
    <template #navigation>
      <NavigationButtonBackFromLinks :links="breadcrumbLinks" />
    </template>
    <TemplateContentAside>
      <TemplateSectionWithHeader>
        <template #header>
          <div class="header-with-action">
            <heading tag="h1" icon="subjects">
              {{ category.title }}
            </heading>
            <AssessmentRunButtonDelete :uuid="uuid" />
          </div>
        </template>
        <DisplaySection gap="m">
          <AssessmentRunViewChapters
            :m-progression-by-chapter="mProgressionByChapter"
          />
        </DisplaySection>
      </TemplateSectionWithHeader>
      <template #aside>
        <DisplaySection class="asside-container">
          <AssessmentListItem
            :assessment="items[0]"
            :show-access-button="false"
            :show-chapters="false"
            :is-link="false"
          />
          <AsideSections
            v-if="hasChildren"
            theme="neutral-50"
            aspect="square"
            stroke="n"
            elevate="none"
          />
        </DisplaySection>
      </template>
    </TemplateContentAside>
  </TemplateContentSubNav>

  <ModalCategory />
</template>
<script setup lang="ts">
import { EventView } from '~/types/adamTypes';

const { categoryManager, contentMemberId } = inject(INJECT_CATEGORY_PAGE);

const { category } = categoryManager;

const progressionExercises = useProgressionExercises(
  contentMemberId,
  categoryManager
);

const appEventAssessmentRun = useAppEventAssessmentRun();

provide(INJECT_PROGRESSION_EXERCISES, progressionExercises);

const route = useRoute();

const uuid = route.params.lb_or_eval as string;

const { load, items, mProgressionByChapter } = useAssessmentsList([uuid]);
await load();

useWebsiteHead({ title: 'Ton éval' });

const breadcrumbLinks = [
  { url: `/${Sections.ChildForYou}`, label: 'Pour toi' },
  {
    url: route.path,
    label: 'Ton éval',
  },
];

const pageContent = ref<HTMLElement>(null);

const { top: offset } = useElementBounding(pageContent);

const anchorsList = useAnchors(offset) || null;

const anchors = anchorsList?.anchors;

const disciplineId = computed<string>(() => {
  return items?.value[0].disciplineId || null;
});

const chapterIds = computed<string[]>(() => {
  return items?.value[0].chapterIds || null;
});

provide(INJECT_ANCHORS, anchorsList);

if (category.value.contentType === ContentTypes.Discipline) {
  useAppEventView(EventView.Discipline, category.value.id);
}

if (category.value.customerSponsorId) {
  useAppEventView(EventView.Category, category.value.id, {
    ContentType: category.value.contentType,
    SponsorId: category.value.customerSponsorId,
  });
}

const hasChildren = computed(() =>
  anchors ? anchors.value.length > 0 : false
);

onMounted(() => {
  if (!disciplineId.value || !chapterIds.value) return;
  appEventAssessmentRun.opened(disciplineId.value, chapterIds.value);
});
</script>
<style lang="scss" scoped>
.header-with-action {
  display: grid;
  grid-template-columns: 1fr auto;
}
</style>
